export default __webpack_public_path__ + "static/bentoSectionImg2-ec7ce3dd967f9fb8c85d383393ede0ed.webp";